import React from 'react';
import { renderPreviewContent } from '../utils';

type Props = {
  messageContent: string;
  selectedSize: string;
  selectedTextColor: string;
  selectedBgColor: string;
};

export const MessagePreview = ({ messageContent, selectedSize, selectedTextColor, selectedBgColor }: Props) => {
  return (
    <div className="flex flex-col gap-[8px]">
      <label className="text-[14px] text-primary noto-sans-jp-medium">
        プレビュー
      </label>
      <div className="border border-gray-300 rounded-[8px] p-[16px] min-h-[80px] bg-gray-50">
        {messageContent && (
          <div
            className={`p-[8px] rounded-[4px] ${
              selectedSize === '大' ? 'text-[18px]' : 
              selectedSize === '中' ? 'text-[16px]' : 'text-[14px]'
            } ${
              selectedTextColor === '黄' ? 'text-yellow-400' :
              selectedTextColor === '赤' ? 'text-red-500' : 'text-white'
            } ${
              selectedBgColor === '赤' ? 'bg-red-600' : 'bg-black'
            } noto-sans-jp-regular`}
          >
            {renderPreviewContent(messageContent)}
          </div>
        )}
      </div>
    </div>
  );
}; 